module.exports = __webpack_public_path__ + "static/media/worldwide.add03217.svg";